import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { FormsModule } from '@angular/forms';
import { MaterialModule } from '../material/material.module';
import { EditUserDialogComponent } from './edit-user-dialog.component';
import { NgxCurrencyWrapperModule } from '../../shared/ngx-currency-wrapper.module';
import { SavedDialogComponent } from '../save-dialog/saved-dialog.component';


@NgModule({
    imports: [
        CommonModule,
        MaterialModule,
        FlexLayoutModule.withConfig({ useColumnBasisZero: false }),
        FormsModule,
        NgxCurrencyWrapperModule
    ],
    exports: [EditUserDialogComponent, SavedDialogComponent],
    declarations: [EditUserDialogComponent, SavedDialogComponent]
})
export class EditUserDialogModule { }
